angular.module('rjmNg.directives').directive "bccSearchList", [
  "emailSummaryEnums"
  (emailSummaryEnums) ->
    restrict: "A"
    templateUrl: "directive.bccSearchList.html"
    replace: true
    scope:
      bccStatuses: "="
    link: (scope) ->
      scope.searchClicked = false
      scope.validEmail = false

      scope.toggleSelected = (bcc) ->
        bccStatus = _(scope.bccStatuses).findWhere {bcc: bcc}
        bccStatus.selected = !bccStatus.selected

      # For custom inputs, add the appropriate user if the address does not already exist
      # in the inputs.
      scope.addEmail = ->
        # Check if the bcc already exists in bccStatuses. If so, just toggle that one.
        if _(scope.bccStatuses).find((bccStatus) -> bccStatus.bcc == scope.query)
          scope.toggleSelected(scope.query)
        else
          scope.bccStatuses.push {'bcc': scope.query, 'selected': true }
        scope.query = ""

      scope.validateEmail = ->
        isValidEmail = scope.query != "" and scope.query.match(emailSummaryEnums.EMAIL_REGEXP)
        isAlreadySelected = _(scope.bccStatuses).find((bccStatus) -> bccStatus.bcc == scope.query && bccStatus.selected==true)?

        if isValidEmail and not isAlreadySelected
          scope.validEmail = true
        else 
          scope.validEmail = false
  ]
